import { GlobalFiltersPerCustomer, ActiveProductLinesIds } from '../models/global-filters.interface';
import { GlobalFiltersActions, GlobalFiltersActionTypes } from './actions';

export interface FiltersState {
  filterPerCustomer: GlobalFiltersPerCustomer;
  activeProductLinesIdsPerJobsite: ActiveProductLinesIds;
  jobsiteFilter: string;
  jobsiteLoader: boolean;
  productLineLoader: boolean;
  selectingJobsite: boolean;
  podLoader?: boolean;
}

const initState: FiltersState = {
  filterPerCustomer: {},
  activeProductLinesIdsPerJobsite: {},
  jobsiteFilter: '',
  jobsiteLoader: false,
  productLineLoader: false,
  selectingJobsite: false,
  podLoader: false,
};

export function filterReducer(state = initState, action: GlobalFiltersActions): FiltersState {
  switch (action.type) {
    case GlobalFiltersActionTypes.SET_JOBSITES: {
      const filterPerCustomer = { ...state.filterPerCustomer[action.customerId] };
      filterPerCustomer.jobsites = action.jobsites;
      return { ...state, filterPerCustomer: { ...state.filterPerCustomer, [action.customerId]: filterPerCustomer } };
    }

    case GlobalFiltersActionTypes.SET_ALL_JOBSITES: {
      const filterPerCustomer = { ...state.filterPerCustomer[action.customerId] };
      filterPerCustomer.allJobsites = action.jobsites;
      return { ...state, filterPerCustomer: { ...state.filterPerCustomer, [action.customerId]: filterPerCustomer } };
    }

    case GlobalFiltersActionTypes.SELECT_JOBSITE: {
      const filterPerCustomer = { ...state.filterPerCustomer[action.customerId] };
      filterPerCustomer.selectedJobsiteId = action.jobsiteId;
      return { ...state, filterPerCustomer: { ...state.filterPerCustomer, [action.customerId]: filterPerCustomer } };
    }

    case GlobalFiltersActionTypes.SET_JOBSITE_LOADER: {
      return { ...state, jobsiteLoader: action.payload };
    }

    case GlobalFiltersActionTypes.SET_SELECTING_JOBSITE: {
      return { ...state, selectingJobsite: action.payload };
    }

    case GlobalFiltersActionTypes.SET_JOBSITE_FILTER: {
      return { ...state, jobsiteFilter: action.payload };
    }

    case GlobalFiltersActionTypes.SET_PRODUCT_LINES: {
      const filterPerCustomer = { ...state.filterPerCustomer[action.customerId] };
      filterPerCustomer.productLines = action.productLines;
      return { ...state, filterPerCustomer: { ...state.filterPerCustomer, [action.customerId]: filterPerCustomer } };
    }

    case GlobalFiltersActionTypes.SET_ACTIVE_PRODUCT_LINES: {
      return {
        ...state,
        activeProductLinesIdsPerJobsite: {
          ...state.activeProductLinesIdsPerJobsite,
          [action.jobsiteId]: action.productLinesIds,
        },
      };
    }

    case GlobalFiltersActionTypes.SELECT_PRODUCT_LINES: {
      const filterPerCustomer = { ...state.filterPerCustomer[action.customerId] };
      filterPerCustomer.selectedProductLinesIds = action.productLinesIds;
      return { ...state, filterPerCustomer: { ...state.filterPerCustomer, [action.customerId]: filterPerCustomer } };
    }

    case GlobalFiltersActionTypes.SET_PRODUCT_LINE_LOADER: {
      return { ...state, productLineLoader: action.payload };
    }

    case GlobalFiltersActionTypes.SET_PODS_LOADER: {
      return { ...state, podLoader: action.payload };
    }

    case GlobalFiltersActionTypes.SELECT_POD: {
      const filterPerCustomer = { ...state.filterPerCustomer[action.customerId] };
      filterPerCustomer.selectedPodId = action.podId;
      return { ...state, filterPerCustomer: { ...state.filterPerCustomer, [action.customerId]: filterPerCustomer } };
    }

    case GlobalFiltersActionTypes.SET_PODS: {
      const filterPerCustomer = { ...state.filterPerCustomer[action.customerId] };
      if (!filterPerCustomer.pods) {
        filterPerCustomer.pods = {};
      }
      filterPerCustomer.pods[action.jobsiteId] = action.pods;
      return { ...state, filterPerCustomer: { ...state.filterPerCustomer, [action.customerId]: filterPerCustomer } };
    }

    default: {
      return state;
    }
  }
}
